import { lazyGetOTelAddinsLogger } from 'owa-analytics';
import { getClientId, getClientVersion, getLogicalRing } from 'owa-config';
import { getGuid } from 'owa-guid';

const AUG_LOOP_ARIA_TENANT_TOKEN =
    '3de4087d4de34817b1c376e3d1e6e293-983c4292-5ba9-485a-ab10-9797863c788b-6770';

let eventSequence = 0;
let clientGuid: string | undefined = undefined;

export async function logALTelemetryEvent(
    _tenant: string,
    eventName: string,
    data: any,
    contract: string,
    contractData: any,
    _critical: boolean
) {
    const event = {
        name: eventName,
        properties: {},
    };

    if (data) {
        Object.keys(data)?.forEach((key: string) => {
            event.properties[`Data_${key}`] = data[key];
        });
    }

    // If contract is 'Office.System.Activity' then contractData should be included with the event data
    if (contract === 'Office.System.Activity' && contractData) {
        Object.keys(contractData)?.forEach((key: string) => {
            event.properties[`Activity_${key}`] = contractData[key];
        });
    }

    if (!clientGuid) {
        clientGuid = toGuid(getClientId());
    }

    const underscoreRegex = /_/gi;
    event.properties['App_Name'] = 'Outlook';
    event.properties['App_Platform'] = 'Web';
    event.properties['App_Version'] = getClientVersion();
    event.properties['Event_Contract'] = contract;
    event.properties['Event_Name'] = eventName?.replace(underscoreRegex, '.');
    event.properties['Event_Time'] = new Date();
    event.properties['Event_Sequence'] = eventSequence++;
    event.properties['Event_Source'] = 'OWA';
    event.properties['Release_AudienceGroup'] = getAudienceGroup();
    event.properties['Session_Id'] = clientGuid;

    const logger = await lazyGetOTelAddinsLogger(AUG_LOOP_ARIA_TENANT_TOKEN);
    logger.logEvent(event);
}

function getAudienceGroup(): string {
    switch (getLogicalRing()) {
        case 'Dogfood':
            return 'Dogfood';
        case 'Microsoft':
            return 'Microsoft';
        case 'FirstRelease':
        case 'WW':
        default:
            return 'Production';
    }
}

function toGuid(guid: string) {
    if (guid !== undefined) {
        return `${guid.slice(0, 8)}-${guid.slice(8, 12)}-${guid.slice(12, 16)}-${guid.slice(
            16,
            20
        )}-${guid.slice(20)}`.toLowerCase();
    } else {
        return getGuid();
    }
}
